import { useState, useEffect, useContext } from "react";
import { DatabaseValue } from "../contexts/database";
import styles from "./styles.module.css";
import { Select, Option } from "../select";

export default function DataSort({ value, onChange, params }) {
  const [_value, setValue] = useState({
    field: "createdDate",
    direction: "asc",
  });
  const tables = useContext(DatabaseValue);
  const [fields, setFields] = useState(null);

  const handleFieldChange = (field) => {
    const value = { ..._value };
    value.field = field;
    setValue(value);
    onChange(value);
  };

  const handleDirectionChange = (direction) => {
    const value = { ..._value };
    value.direction = direction;
    setValue(value);
    onChange(value);
  };

  useEffect(() => {
    if (value) {
      setValue(value);
    } else {
      setValue({ field: "createdDate", direction: "asc" });
    }
  }, [value]);

  useEffect(() => {
    const table = tables.find((x) => x.id === params.type);
    if (table) {
      const fields = Object.keys(table.fields)
        .map((key) => {
          return { ...table.fields[key], id: key };
        })
        .filter((x) => {
          return (
            (x.type === "Date" || x.type === "Text" || x.type === "Number") &&
            x.list === false
          );
        })
        .sort((x, y) => {
          console.log(x.name > y.name);
          return x.name.toLowerCase() > y.name.toLowerCase() ? 1 : -1;
        });
      setFields(fields);
    }
  }, [params.type]);

  if (!fields) {
    return null;
  }
  return (
    <div className={styles.dataSort}>
      <div className={styles.workflowParamTitle}>Field</div>
      <Select value={_value.field} onChange={handleFieldChange}>
        {fields.map((f) => {
          return (
            <Option value={f.id} key={f.id}>
              {f.name}
            </Option>
          );
        })}
      </Select>
      <div style={{ marginTop: 12 }} className={styles.workflowParamTitle}>
        Direction
      </div>
      <Select value={_value.direction} onChange={handleDirectionChange}>
        <Option value={"asc"}>Ascending</Option>
        <Option value={"desc"}>Descending</Option>
      </Select>
    </div>
  );
}
